import NewGalleryItem from './NewGalleryItem';
export default NewGalleryItem;
